/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft budget sheet with category totals and a budget-versus-actual chart`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 预算表，包含分类合计与预算和实际支出对比图`)
};

/**
* | output |
* | --- |
* | "GridCraft budget sheet with category totals and a budget-versus-actual chart" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_1_figure_alt as "gc.search_guides.gridcraft_vs_excel.sections.1.figure.alt" }